module.exports = __webpack_public_path__ + "static/media/open_box.abb2171a.mp3";